import { Component } from '@angular/core';
import { data } from 'src/app/data';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    data=data;
    isuk = false;
    email = '';
    phone = [];
    address='';
    constructor() { 
        var abc =window.location.href;
        if(abc.includes('.co.uk')){
            console.log('Redirecting to UK site');
            this.isuk = true;
           this.email=this.data.storeemailuk;
              this.phone=this.data.storephoneuk;
                this.address=this.data.storeaddressuk;
        }
        else
        {
            console.log('Redirecting to US site');
            this.isuk = false;
            this.email=this.data.storeemail;
                this.phone=this.data.storephone;
                    this.address=this.data.storeaddress;
        }
    }
}
 